import React, { useEffect, useState } from "react";
import cssStyles  from "./question.module.scss";
import Typography from '@mui/material/Typography';
import { Alert, Paper } from "@mui/material";
interface QuestionComponentData {
    title: string;
    description?: string;
    qlabel?: string;
    Element?: any;
    elementProps?: any;
    key? : any;
    isMinSelQuestion?: any;
}

const QuestionComponent: React.FC<QuestionComponentData> = ({isMinSelQuestion, title,description,qlabel,Element,key, elementProps}) => {
    const [choiceAlertTop, setChoiceAlertTop] = useState(undefined);

    useEffect(() => {
        const choiceAlertEl: any = document.getElementById('choice_alert');
        setChoiceAlertTop(choiceAlertEl?.getBoundingClientRect()?.top + 42);
    }, [choiceAlertTop]);

    useEffect(() => {
        if (!choiceAlertTop) return;
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    }, [choiceAlertTop]);

    const isSticky = () => {
        const choiceAlertEl: any = document.getElementById('choice_alert');
        //const footerEl: any = document.getElementById('footer-a');
        const scrollTop = window.scrollY;
        if (choiceAlertTop) {
            if (scrollTop >= choiceAlertTop - 10) {
                choiceAlertEl?.classList?.add('is-sticky');
                //footerEl.classList.add('is-sticky');
            } else {
                choiceAlertEl?.classList?.remove('is-sticky');
                //footerEl.classList.remove('is-sticky');
            }            
        }
    }
    return (<>
        <Paper elevation={3} sx={{padding: '30px'}} square className={cssStyles["question-container"]}> 
            <Typography component={'h1'} className={cssStyles["about_heading"]}>
            {title}
            </Typography> 
            <div id="choice_alert" className={cssStyles["selection_alert"]}>{(elementProps.minSelections > 0 && isMinSelQuestion && elementProps.selectedAnswer.length < elementProps.minSelections) && (elementProps.selectedAnswer.length + '/' + elementProps.minSelections + ' selected')}</div>
            {/* <Typography component={'h2'} className={elementProps.minSelections > 0? cssStyles["about_heading2"] : ""}>
                 {(elementProps.minSelections > 0 && elementProps.selectedAnswer.length <7)  ? `Selected Choices ${elementProps.selectedAnswer.length} / ${elementProps.minSelections}` : `` }
            </Typography>  */}

            <Typography
                component="p"
                variant="subtitle1"
                dangerouslySetInnerHTML={{
                    __html: (description ?? "").replace(/\{min_selections\}/g, elementProps.minSelections),
                }}
            />

            <Typography component={'p'} sx={{
                fontFamily: 'Nunito',
                fontWeight: 500,
                lineHeight: "24px",
                fontSize: "20px",
                fontStyle: "normal",
                mb: '10px'
            }}>
                {qlabel}
            </Typography>
            <Element key={key} {...elementProps} style={elementProps.style} />
        </Paper>
    </>)
}

export default QuestionComponent;